import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import { INSIGHT_FILTERS } from "utility/constants/constants";

const defaultFilterOptions = [
    { value: "All Apps", label: <span className="font-size-normal">All Apps</span>},
    { value: "Starred", label: <span  className="font-size-normal">Starred</span>},
    { value: "Template", label: <span  className="font-size-normal">Template</span> },
    { value: "Created by me", label: <span  className="font-size-normal">Created by me</span> },
    { value: "Shared with me", label: <span  className="font-size-normal">Shared with me</span> }
  ];

const sortOptions = [
  {
    value:1,
    sortByValue: "DESC",
    orderByValue: "name",
    label: <span className="font-size-normal">Reverse Alphabetical Name</span>
  },
  {
    value:2,
    sortByValue: "ASC",
    orderByValue: "name",
    label: <span className="font-size-normal">Alphabetical Name</span>
  },
  {
    value:3,
    sortByValue: "DESC",
    orderByValue: "created_at",
    label: <span className="font-size-normal">Newest Created</span>,
  },
  {
    value:4,
    sortByValue: "ASC",
    orderByValue: "created_at",
    label: <span className="font-size-normal">Oldest Created</span>,
  },
  {
    value:5,
    sortByValue: "DESC",
    orderByValue: "updated_at",
    label: <span className="font-size-normal">Newest Updated</span>,
  },
  {
    value:6,
    sortByValue: "ASC",
    orderByValue: "updated_at",
    label: <span className="font-size-normal">Oldest Updated</span>,
  },
];

const customStyles = {
    menu: provided => ({ ...provided, zIndex: 9999, width: "max-content", minWidth: "100%" }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#DBDDFF;' : provided.backgroundColor,
      fontFamily: 'Lato', // Specify the desired font family
      fontSize: '16px', // Specify the desired font size
      borderColor: '#FFF',
      width: "max-content",
      minWidth: "100%"
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: '#6B71FB',
      }),
    // Add more styles for other components if needed
    indicatorSeparator: (base, state) => ({
        ...base,
        // Custom styles for the indicator separator
        display: 'none', // Hide the indicator separator
      }),
    dropdownIndicator: (base, state) => ({
        ...base,
        // Custom styles for the dropdown indicator
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        transform: state.selectProps.menuIsOpen ? 'rotate(0deg)' : null, // Prevent rotation
        transition: 'transform 0.3s ease', // Add a transition effect if needed
      })
  };

// Custom dropdown indicator component with a custom image
const CustomDropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img
          src={require("assets/custom-styles/images/icons/filterIcon.svg")}
          alt="Custom Dropdown Indicator"
          style={{ width: '20px', height: '20px' }}
        />
      </components.DropdownIndicator>
    );
  };



const FilterInsights = ({setAppTypeSort, appTypeSort, entityFilterOptions }) => {
  // Internal state for the search input field
  const [searchInput, setSearchInput] = useState(appTypeSort.search || "");
  const filterOptions = entityFilterOptions ? entityFilterOptions : defaultFilterOptions;

  // Effect 1: Synchronize internal searchInput state with appTypeSort.search prop
  // This ensures that if the parent resets the search term, the input field updates.
  useEffect(() => {
    // Directly set searchInput based on the prop.
    // If appTypeSort.search is already the same as searchInput,
    // React's useState setter is smart enough not to cause an unnecessary re-render.
    setSearchInput(appTypeSort.search || "");
    // Only depend on appTypeSort.search for this effect, as we are only reacting to its changes.
  }, [appTypeSort.search]);

  // Effect 2: Debounce the update to the parent component (appTypeSort)
  // This happens when the user types into the search input (searchInput changes).
  useEffect(() => {
    const debounceFn = setTimeout(() => {
      // Only call setAppTypeSort if the current internal searchInput
      // is different from what's already in appTypeSort.search to prevent redundant updates.
      if (searchInput !== appTypeSort.search) {
        setAppTypeSort(prevAppTypeSort => ({ ...prevAppTypeSort, page: 1, search: searchInput }));
      }
    }, 500);
    return () => clearTimeout(debounceFn);
    // This effect depends on searchInput to trigger the debounce on type,
    // appTypeSort to compare against the current parent state,
    // and setAppTypeSort to perform the update.
  }, [searchInput, appTypeSort, setAppTypeSort]);

  // Determine the currently selected filter option for the Select component
  const selectedFilterOption = filterOptions.find(option => {
    // Assuming option.value is a string like "All Apps" or "Created by me"
    // And INSIGHT_FILTERS maps these (lowercased) to backend values like "all" or "owned"
    const optionKey = typeof option.value === 'string' ? option.value.toLowerCase() : '';
    return INSIGHT_FILTERS[optionKey] === appTypeSort.filter;
  });

  // Determine the currently selected sort option for the Select component
  const selectedSortOption = sortOptions.find(
    option => option.orderByValue === appTypeSort.orderBy && option.sortByValue === appTypeSort.sortOperator
  );

  return (
    <div className="filter_container">
        <Select
            menuPlacement="auto"
            placeholder="Filter"
            className="filterInsightDropdown"
            name="filter"
            autosize={false}
            options={filterOptions}
            value={selectedFilterOption}
            components={{ DropdownIndicator: CustomDropdownIndicator }}
            onChange={(selectedOption) => {
                // Ensure selectedOption and selectedOption.value are not null/undefined
                if (selectedOption && typeof selectedOption.value === 'string') {
                    const filterValue = INSIGHT_FILTERS[selectedOption.value.toLowerCase()];
                    setAppTypeSort({...appTypeSort, page: 1, filter: filterValue });
                }
            }}
            styles={customStyles}
        />
        <Select
            menuPlacement="auto"
            placeholder="Sort"
            className="filterInsightDropdown"
            name="sort"
            options={sortOptions}
            value={selectedSortOption}
            autosize={false}
            components={{ DropdownIndicator: CustomDropdownIndicator }}
            onChange={(selectedOption) => {
                // Ensure selectedOption is not null/undefined
                if (selectedOption) {
                    setAppTypeSort({
                        ...appTypeSort,
                        page: 1,
                        orderBy: selectedOption.orderByValue,
                        sortOperator: selectedOption.sortByValue
                    });
                }
            }}
            styles={customStyles}
        />
        <div className="search_container">
            <img src={require('assets/custom-styles/images/icons/magnifyingGlass.svg')} alt="" />
            <input
                style={{border:'none'}}
                type="text"
                placeholder="Search by name"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}/>
        </div>
    </div>
  );
};
export default FilterInsights;
